export const generateCode = () => {
  const ret = ['window.console=window.parent.console'];

  // POLYFILL_SRC 是 webpack 注入的变量
  // @ts-ignore 
  (POLYFILL_SRC as string[]).forEach((src) => {
    ret.push(`document.writeln('<script src="${src}"></script>')`);
  });

  // POLYFILL_CONTENT 是 webpack 注入的变量
  // @ts-ignore 
  (POLYFILL_CONTENT as string[]).forEach((content) => {
    ret.push(content);
  });

  return ret.join(';');
};
